module.exports = __webpack_public_path__ + "67c8d26aec153e3b0af891d83af0fe23.pdf";